var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(19944 -14392)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 24,
    height: 24,
    transform: "translate(-19944 14392)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(-19943.582 14392.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M13.167,1.842a.545.545,0,0,0-.933.367V5.117a2.272,2.272,0,0,0,2.292,2.225c.792.008,1.892.008,2.833.008a.526.526,0,0,0,.392-.892C16.55,5.25,14.4,3.075,13.167,1.842Z",
    transform: "translate(3.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M20.083,9.857h-2.89a4.306,4.306,0,0,1-4.3-4.3V2.667a1,1,0,0,0-1-1H7.653a5.277,5.277,0,0,0-5.57,5.57V16.1a5.277,5.277,0,0,0,5.57,5.57h7.86a5.277,5.277,0,0,0,5.57-5.57v-5.24A1,1,0,0,0,20.083,9.857Zm-9,7.56h-4a.75.75,0,1,1,0-1.5h4a.75.75,0,0,1,0,1.5Zm2-4h-6a.75.75,0,1,1,0-1.5h6a.75.75,0,1,1,0,1.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsInactive);
export default __webpack_public_path__ + "static/media/reports_inactive.40e1e0ce428dff0f2be0576d670fff38.svg";
export { ForwardRef as ReactComponent };